export default __webpack_public_path__ + "static/media/nflStaff5.11c4cf3f.jpg";